<script>
import formatCurrency from "@utils/format-currency";
import { nlToBr } from "@utils";
import { merchantComputed, authComputed } from '@store/helpers'
import { memberLevelPriceDiscount } from "@utils/ipetbooking-level";
export default {
  props: {
    depositList: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      selectedUuid: ''
    }
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },

    activeContent() {
      return this.depositList.find(({ uuid }) => uuid === this.selectedUuid) || ''
    },
  },
  watch: {
    activeContent: {
      immediate: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.submitData = this.activeContent || {}
        })
      }
    },
  },
  mounted() {
    this.initDefaultDepositItem()
  },
  methods: {
    nlToBr,
    formatCurrency,
    memberLevelPriceDiscount,
    calcDiscount(item, pos = 1) {  
      const num = (item.levelDiscount > 0 ? memberLevelPriceDiscount(item.price, item) : item.price) / item.point
      const size = Math.pow(10, pos);
      return Math.round(num * size) / size;
    },
    formatDiscount(discount) {
      return discount * 10
    },
    initDefaultDepositItem() {
      if(this.depositList.length) {
        this.submitData = this.depositList[0]
      }
    },
    openLoginDialog() {
      this.$globalDialog('DialogLogin', { callbackLogin() {} })
    },

  }
}
</script>
<!-- section template -->
<template>
  <div :class="[$style.sectionContent, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
    <button v-if="!isLoggedIn" class="baseButton isStylePrimary isFull" @click="openLoginDialog">快速登入</button>
    <el-select v-else
      v-model="selectedUuid"
      class="isStyleFilter w-100 mb-3"
      :popper-class="$style.depositdepositList"
    >
      <el-option
        v-for="item in depositList"
        :key="item.value"
        :label="item.title"
        :value="item.uuid"
        :class="[$style.depositItem, { 'isStyleDingBeauty': $globalIsDingBeauty }]"
      >
        <div class="depositItem__contentBox">
          <i v-if="!!item.keepTop && $globalIsJtails" class="fontello fontello-paw fa-2x mb-2"></i>
          <i v-if="!!item.keepTop && $globalIsDingBeauty" class="fontello fontello-db-lipstick fa-2x mb-2 fs-xl"></i>
          <div>
            <span class="depositItem__title font-number">{{ item.title }}</span>
            <br>
            <span class="depositItem__info font-number d-md-inline d-none">{{ `儲值NT $${formatCurrency(item.levelDiscount > 0 ?  memberLevelPriceDiscount(item.price, item) : item.price)}可用${formatCurrency(item.point)}點` }}</span>
            <span v-if="calcDiscount(item) < 0.95 " class="depositItem__discount font-number d-md-inline d-none">{{ `，約享近${formatDiscount(calcDiscount(item))}折！` }}</span>
          </div>
          <div 
            class="depositItem__price font-number d-flex align-items-center"
          >
            售價NT ${{ formatCurrency(item.levelDiscount > 0 ?  memberLevelPriceDiscount(item.price, item) : item.price) }}
          </div>
        </div>
      </el-option>
    </el-select>
    <template v-if="activeContent">
      <div class="mb-4">
        <!-- <div class="sectionContent__itemPoint font-number fw-black d-inline">儲值<span class="text-secondary">{{ formatCurrency(activeContent.point) }}點</span></div> -->
        <span class="sectionContent__itemPrice font-number">
          {{ activeContent.levelDiscount > 0 
            ? `會員價 NT$ ${formatCurrency( memberLevelPriceDiscount(activeContent.price, activeContent))}`
            : `NT$ ${formatCurrency(activeContent.price)}`
          }}
        </span>
        <span 
          v-if="activeContent.levelDiscount > 0 "
          class="text-decoration-line-through fs-sm font-number ml-2 sectionContent__itemSmallPrice"
        > {{ `售價 NT$ ${formatCurrency(activeContent.price)}`}}
        </span>
      </div>
      <div class="sectionContent__itemTitle fw-black">{{ activeContent.title }}</div> 
      <div class="mt-2">
        <span class="sectionContent__itemInfo font-number">{{ `儲值NT $${formatCurrency(activeContent.price - Math.round( activeContent.price * (currentMember.level.discount.deposit / 100) ))}可使用儲值點數${formatCurrency(activeContent.point)}點` }}</span>
        <span v-if="calcDiscount(activeContent) < 0.95 " class="sectionContent__itemDiscount font-number">{{ `，約享近${formatDiscount(calcDiscount(activeContent))}折！` }}</span>
      </div>
      <template v-if="activeContent.description">
        <hr>
        <BaseSectionTitleJtails
          v-if="!$globalIsDingBeauty"
          title="方案內容"
          sub-title="Instruction"
        />
        <BaseSectionTitleSecondary
          v-else
          title="方案內容"
        />
        <div class="sectionContent__itemDescription mb-3" v-html="nlToBr(activeContent.description)"></div>
      </template>
      <!-- <BaseButton class="isStylePrimary isFull isRadius mb-5" :loading="loadingStoreCart" @click="onClickPurchase">立即購買</BaseButton> -->
    </template>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.sectionContent {
  position: relative;

  :global {
    .sectionContent {
      &__image {
        background-position: center;
        background-size: cover;
        padding-top: 38.23%;
        margin-bottom: 2.5rem;
      }

      &__description {
        font-size: 1rem;
        line-height: 1.75rem;
        letter-spacing: .15rem;
        margin-bottom: 1.5rem;
        color: $color-gray-2;
      }

      &__itemTitle {
        color: $color-primary-dark;
        font-size: 1.25rem;
        line-height: 1.875rem;
        font-weight: 500;
        @include max-md {
          font-size: 1.125rem;
        }
      }

      &__itemInfo {
        color: $color-gray-2;
        font-size: 1rem;
      }

      &__itemDiscount {
        font-size: 1rem;
        color: $color-primary-dark;
      }

      &__itemDescription {
        color: $color-gray-2;
        font-size: 1rem;
      }

      &__itemPoint {
        font-size: 1.5rem;
        color: $color-gray-1;
        @include max-md {
          font-size: 1.25rem;
        }
      }

      &__itemPrice {
        color: $color-primary;
        font-size: 1.5rem;
        font-weight: 500;
        @include max-md {
          font-size: 1.25rem;
        }
      }
      &__itemSmallPrice {
        color: #B9B9B9;
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .sectionContent {
        &__itemTitle {
          color: $color-secondary;
        }
        &__itemDiscount {
          font-size: 1rem;
          color: $color-gray-2;
        }
        &__itemPrice {
          color: $color-secondary;
        }
      }
    }
  }
}

.depositdepositList {
  :global {
    .el-select-dropdown__item.selected::before {
      top: 50% !important;
      transform: translateY(-50%) !important;
    }
  }
}

.depositItem {
  padding-left: 3.5rem !important;

  :global {
    .depositItem {
      &__contentBox {
        display: flex;
        justify-content: space-between;
        align-content: center;
        position: relative;

        > i {
          position: absolute;
          top: 7px;
          left: -31px;
          color: $color-primary;
          transform: rotate(-45deg);
          font-size: 1.25rem;
        }
      }

      &__title {
        font-size: 1rem;  
      }

      &__info {
        font-size: .875rem;
        color: $color-gray-2;
      }

      &__discount {
        color: $color-primary;
      }

      &__price {
        font-size: 1rem;  
      }
    }
  }
  &:global {
    &.isStyleDingBeauty {
      .depositItem{
        &__contentBox {
          > i {
            transform: rotate(0);
          }
        }
      }
    }
  }
}
</style>
